module.exports = __webpack_public_path__ + "img/baumkontrolle.10ce83b6.svg";